import palette from '@/assets/palette';

export const backgroundColorMethod = {
  0: palette.cello40,
  1: palette.green40,
  3: palette.green20,
  4: palette.cello30,
  13: palette.orange20,
  14: palette.magenta40,
  15: palette.orange40,
  17: palette.blue40,
  19: palette.cello10,
  21: palette.cello60,
  23: palette.magenta60,
  25: palette.mediumGrey,
  30: palette.magenta20,
  35: palette.blue35
};
